// Fixtures for the Connections tab (D0). One approved specimen from real X2
// output shape, one unapproved, one stale, one suppressed — the gate's four
// dispositions, so the dev page shows exactly one card and three withholdings.
const approvedTemplate = {
  pairing_version: 1,
  scene: { movie_id: 8300, scene_number: 26 },
  shared_moment: {
    label: 'The montage lists four tourist activities in unbroken sequence.',
    quotations: [{ text: 'sea lions at Pier 39' }, { text: 'Irish coffee at the Buena Vista' }],
  },
  pairings: [
    { scene_mechanics_axis: 'economy', craft_read_criterion: 'pacing',
      why: 'The repeated activities are the same drag the pacing note describes — one behaviour, two vocabularies.' },
  ],
  provenance: { prompt_sha256: 'sha256:fd76826e', packet_render_version: 'bp/2|esc=ent-noquotes/1|der=full|handles=1|clean=v2|producer=both', envelope: '8300_s26_r0.json', pattern_ordinal: 0 },
  approval: null,   // minted by makeFixtures()
  suppression: null,
};

async function makeFixtures(gate) {
  const ok = JSON.parse(JSON.stringify(approvedTemplate));
  ok.approval = { approved_key: await gate.contentKey(ok), approved_by: 'fixture', approved_at: '2026-08-12' };
  const unapproved = JSON.parse(JSON.stringify(approvedTemplate));
  const stale = JSON.parse(JSON.stringify(ok));
  stale.shared_moment.label = 'A regenerated, different label.';
  const suppressed = JSON.parse(JSON.stringify(ok));
  suppressed.suppression = { state: 'scene_text_changed' };
  return [ok, unapproved, stale, suppressed];
}
module.exports = { approvedTemplate, makeFixtures };
